import React from 'react'
import PropTypes from 'prop-types'
import NavLinkGroup from './NavLinkGroup'

import '../../sass/mainv3.scss'

function LoginButton({ theme, myAccount, loginButton, topbar }) {
  const navLink = theme.isLoggedIn ? (
    <NavLinkGroup linkGroups={myAccount[0]} topbar={topbar} />
  ) : (
    <NavLinkGroup linkGroups={loginButton} topbar={topbar} theme={theme} />
  )

  return navLink
}

LoginButton.defaultProps = {
  topbar: false
}

LoginButton.propTypes = {
  theme: PropTypes.object.isRequired,
  myAccount: PropTypes.array.isRequired,
  loginButton: PropTypes.object.isRequired,
  topbar: PropTypes.bool
}

export default LoginButton
